//Servicios 
import httpClientePublicoLogin from '../../Servicios/httpClientePublicoLogin';


// Se encacarga de recuperar los datos d un cliente
export const ValidarTipoLoginPortal = (portal) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoLogin.post('/Login/TipoLogin/', {
            Portal: portal
        })
            .then((response) => {
                resolve(response);
            }).catch(error => {
                resolve(error.response);
            });
    });
};